<div class="uniben-notification-backdrop" *ngIf="(isUniben$ | async) && !closed">
  <div
    class="uniben-notification-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="uniben-notification-title"
  >
    <button type="button" class="uniben-notification-close" aria-label="Fechar" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>

    <div class="uniben-notification-body">
      <p id="uniben-notification-title">Prezado(a) cliente,</p>

      <p>
        Informamos que, a partir da competência <strong>10/2026</strong>, suas consultas deverão ser realizadas por um
        novo portal de atendimento.
      </p>

      <p>Para acessar, siga as orientações abaixo:</p>

      <ol>
        <li>
          Acesse o site da Uniben Saúde:
          <a href="https://unibensaude.com.br/" target="_blank" rel="noopener noreferrer">
            Uniben Saúde - Página Inicial
          </a>
        </li>
        <li>Clique na opção “Área do Cliente”.</li>
        <li>Selecione sua operadora e a competência que deseja consultar.</li>
      </ol>

      <p class="uniben-notification-subtitle">Precisa de ajuda?</p>

      <p>Caso tenha dúvidas ou dificuldades para realizar o login, entre em contato com nosso SAC:</p>

      <p class="uniben-notification-contact">
        <span><strong>WhatsApp:</strong> (32) 3771-0333</span>
        <span>
          <strong>E-mail:</strong>
          <a href="mailto:sac@unibensaude.com.br">sac@unibensaude.com.br</a>
        </span>
        <span><strong>Horário de atendimento:</strong> segunda a sexta-feira, das 8h às 17h.</span>
      </p>

      <p>Estamos à disposição para ajudar!</p>
    </div>

    <div class="uniben-notification-actions">
      <a
        href="https://unibenjf.com.br/login"
        target="_blank"
        rel="noopener noreferrer"
        mat-raised-button
        color="primary"
      >
        Acessar portal de atendimento
      </a>
    </div>
  </div>
</div>
